import React, { Component } from 'react'
import './login.css'
import Amplify from 'aws-amplify'
import awsExports from '../aws-exports'
import { Auth, API, Hub } from 'aws-amplify'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import { I18nPropvider, LOCALES } from '../i18nProvider'
import translate from '../i18nProvider/translate'

Amplify.configure(awsExports)

export class LoginPage extends Component {
  state = {
    language: LOCALES.ENGLISH,
    disabled: true,
    isModalVisible: true,
    isVeriVisible: false,
    progressVisible: false,
    alexaState: '',
    alexaRedirct: '',
    client_id: '',
    mailInput: '',
    loginState: '登出',
    mail18n: 'Email',
  }

  componentDidMount() {
    if (navigator.language.toString().includes(LOCALES.JAPAN)) {
      this.setState({
        language: LOCALES.JAPAN,
        mail18n: 'Eメール',
      })
    }

    Auth.currentAuthenticatedUser().then((user) => {
      // console.log('查看用戶user', user)
      if (user.username) {
        this.setState({
          loginState: 'signIn',
        })
      }
    })
    Hub.listen('auth', (data) => {
      this.setState({
        loginState: data.payload.event,
      })
    })
    let search = window.location.search
    let params = new URLSearchParams(search)
    this.setState({
      alexaState: params.get('state'),
      alexaRedirct: params.get('redirect_uri'),
      client_id: params.get('client_id'),
    })
  }

  render() {
    return (
      <I18nPropvider locale={this.state.language}>
        <div style={{ margin: '24px' }}>
          <img
            alt='logo'
            width={100}
            src='https://play-lh.googleusercontent.com/1aJhnph1EOYw8Uxv1OVctDs0e0vAAUbXlkBcyhAT3WGHLdcDraiRbxji4sdKn4PVUA=s360'
          />

          <br />
          <input
            style={{ display: this.state.isModalVisible ? '' : 'none' }}
            className='login-box'
            type='email'
            id='email'
            name='email'
            onChange={(vv) => {
              const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/
              const checkemail = pattern.test(vv.target.value)
              this.setState({
                mailInput: vv.target.value,
                disabled: !checkemail,
              })
            }}
            placeholder='your@email.com'
          />

          <div style={{ display: this.state.isVeriVisible ? '' : 'none' }}>
            <h2>{translate('VerificationCode')}</h2>
            <CircularProgress
              style={{ display: this.state.progressVisible ? '' : 'none' }}
              color='primary'
            />
            <input
              className='login-box'
              type='number'
              id='number'
              name='number'
              onChange={(vv) => {
                // console.log(vv.target.value, vv.target.value.length)
                if (vv.target.value.length === 4) {
                  this.setState({
                    progressVisible: true,
                  })
                  this.goVerify(vv.target.value)
                }
              }}
              placeholder='1234'
            />
          </div>
          <Button
            className='login-btn'
            style={{
              height: '45px',
              marginTop: '16px',
              display: this.state.isModalVisible ? '' : 'none',
            }}
            variant='contained'
            color='primary'
            disabled={this.state.disabled}
            onClick={this.goSingin}
          >
            {translate('log In')}
          </Button>
          <br />
          {/*<div style={{marginTop: '32px'}}>*/}
          {/*    <p>{navigator.language}:alexa_test google_test account verifyCode always be 1111 }</p>*/}
          {/*</div>*/}
          <div style={{ marginTop: '32px' }}>
            <p>
              {this.state.client_id === '2t6zdnech8'
                ? 'Alexa'
                : this.state.client_id === 'partners'
                ? 'Candyhouse Partners'
                : this.state.client_id === 'sesamebiz'
                ? 'SESAME Biz'
                : 'Google'}
              {''}&ensp;will obtain access and be able to control your devices.
            </p>
          </div>
        </div>
      </I18nPropvider>
    )
  }

  goSingin = async () => {
    await Auth.signIn(this.state.mailInput)
      .then((user) => {
        if (user.challengeName === 'CUSTOM_CHALLENGE') {
          this.mUSer = user
          this.setState({
            loginState: '等待驗證',
            isModalVisible: false,
            isVeriVisible: true,
          })
        }
      })
      .catch((err) => {
        console.log('請求驗證碼錯誤', err)
      })
  }
  goVerify = async (vcode) => {
    await Auth.sendCustomChallengeAnswer(this.mUSer, vcode)
      .then((user) => {
        if (user.signInUserSession) {
          API.get('Account-link', 'oauth2/code', {}).then((response) => {
            // console.log('測試回覆', response)
            const verifyCode = response.toString()
            // console.log('verifyCode', verifyCode)
            // console.log('verifyCode', `${this.state.alexaRedirct}?code=${verifyCode}&state=${this.state.alexaState}`)
            window.location = `${this.state.alexaRedirct}?code=${verifyCode}&state=${this.state.alexaState}`
          })
        } else {
          // console.log('處理驗證失敗')
          this.setState({
            loginState: '驗證失敗',
            isModalVisible: true,
            isVeriVisible: false,
          })
        }
      })
      .catch((err) => console.log(err))
  }
}
